import { render, staticRenderFns } from "./ReviewServiceComponent.vue?vue&type=template&id=21859638&"
import script from "./ReviewServiceComponent.vue?vue&type=script&lang=js&"
export * from "./ReviewServiceComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports